<template>
  <div class="teacher">
    <div
      class="detail-card__teacher__item"
      v-for="(item, index) in data"
      :key="index"
      @click="handleClick(item, $event)"
      :style="`cursor: ${item.url || isExcTeacherCourse ? 'pointer' : 'default'}`"
    >
      <div
        class="teacher__avater"
        :style="`background-image:url('${item.avatar}')`"
      ></div>
      <div class="teacher__info">
        <p class="teacher__info__des">
          {{ excTeacherCourse === 1 ? item.description : item.typeName }}
        </p>
        <p class="teacher__info__name">{{ item.name }}</p>
      </div>
      <div class="teacher__url" v-if="item.url || isExcTeacherCourse">
        <p class="teacher__url__logo"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    excTeacherCourse: {
      type: Number,
      default: -1 // -1:授课老师（中文老师|英文老师），0:辅导老师，1:专属老师
    },
    isCounselorTeacher: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  computed: {
    isExcTeacherCourse() {
      return (
        Number(this.isCounselorTeacher) === 1 &&
        this.excTeacherCourse &&
        this.excTeacherCourse === 1
      )
    }
  },
  methods: {
    handleClick(item, event) {
      // 2021春季续报外教老师跳未来号
      // if (item.teacher_type && Number(item.teacher_type) === 5) {
      //   window.open('https://h5.xueersi.com/5daebe50e27d976b2fc7b106.html')
      // } else
      if (this.isExcTeacherCourse) {
        window.open('https://zt.xueersi.com/xueke/2019zsls/')
      } else if (item.url) {
        let routeData = this.$router.resolve({ name: 'teacher-info', params: {teacherId: item.id},  query: this.$route.query })
        window.open(routeData.href, '_blank')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import 'src/scss/entry';
@include b(detail-card) {
  @include e(teacher) {
    @include e(item) {
      position: relative;
      margin: 16px 20px 0 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
    }
  }
}
@include b(teacher) {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  @include e(avater) {
    display: inline-block;
    width: 46px;
    height: 46px;
    background-size: cover;
    border-radius: 100%;
    overflow: hidden;
    background-position: 50%;
    background-repeat: no-repeat;
    border: 1px solid #f1f1f1;
  }
  @include e(info) {
    display: inline-block;
    // width: 62px;
    padding-left: 8px;
    padding-right: 4px;
    & > p {
      font-size: 12px;
      line-height: 24px;
    }
    @include e(des) {
      color: #666666;
    }
    @include e(name) {
      color: #333333;
    }
  }
  @include e(url) {
    // position: absolute;
    // right: -6px;
    display: inline-block;
    // padding: 6px;
    height: 14px;
    width: 14px;
    // background: red;
    @include e(logo) {
      height: 14px;
      width: 14px;
      background: url('../images/rectangle.png');
      background-position: 50%;
      background-size: 14px 14px;
      background-repeat: no-repeat;
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/modules/Teacher.vue